<template>
  <div class="auth-page">
    <vue-element-loading :active="isActive" :is-full-screen="true" spinner="bar-fade-scale" color="#007bce"/>
    <b-container>
      <h5 class="auth-logo">
        <router-link to="/app/dashboard"><span class="thumb-xxl mr-2">
            <img class="" src="../../assets/img/Anlyst_logo.svg" alt="..." />
          </span></router-link>
      </h5>
      <Widget class="widget-auth mx-auto" title="<h3 class='mt-0'>Login to your Web App</h3>" customHeader>
        <p class="widget-auth-info">
            Use your email to sign in.
        </p>
        <form class="mt" @submit.prevent="login">
          <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">
            {{errorMessage}}
          </b-alert>
          <div class="form-group">
            <input class="form-control no-border" ref="email" required type="email" name="email" placeholder="Email" />
          </div>
          <div class="form-group">
            <input class="form-control no-border" ref="password" required type="password" name="password" placeholder="Password" />
          </div>
          <b-button type="submit" size="sm" class="auth-btn mb-3" variant="inverse">Login</b-button>
          <!--<p class="widget-auth-info">or sign in with</p>
          <div class="social-buttons">
            <b-button variant="primary" class="social-button mb-2">
              <i class="social-icon social-google"></i>
              <p class="social-text">GOOGLE</p>
            </b-button>
            <b-button variant="success" class="social-button">
              <i class="social-icon social-microsoft"></i>
              <p class="social-text">MICROSOFT</p>
            </b-button>
          </div>-->
        </form>
        <!--<p class="widget-auth-info">
          Don't have an account? Sign up now!
        </p>
        <router-link class="d-block text-center" to="login">Create an Account</router-link>-->
      </Widget>
    </b-container>
    <!--<footer class="auth-footer">
      2019 &copy; AxCap247 Trader.
    </footer>-->
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import common from '@/assets/js/common.js';
import VueElementLoading from 'vue-element-loading'
import Vue from 'vue';

export default {
  name: 'LoginPage',
  mixins: [common],
  components: { Widget , VueElementLoading },
  data() {
    return {
      errorMessage: null,
      isActive: false,
    };
  },
  methods: {
    async login() {
      this.isActive = true;
      Vue.prototype.$permission = {};
      const email = this.$refs.email.value;
      const password = this.$refs.password.value;

      if (email && password) {
        const res = await this.call_axios('login','post',{email:email,password:password});
        if(res.response.code == 0){
          window.localStorage.setItem('auth_token', res.response.api_token);
          window.localStorage.setItem('auth_user', JSON.stringify(res.response.data.result));
          this.$router.push('/app/dashboard');
          this.isActive = false;
          return;
        }
      }
      this.isActive = false;
      this.$toasted.error("Not a Valid Login",{duration:1000});
      
    },
  },
  created() {
    /*if (!window.localStorage.getItem('auth_token')) {
      this.$router.push('/app/main/analytics');
    }*/
  },
};
</script>